// to work needs to import forms on controller
/* global checkFormFields, fetch */
/* eslint no-undef: "error" */

$(document).ready(function () {
  const inputEmail = $('input[name=pf_Email]')
  const strings = $('.newsletter--page').data('strings')

  inputEmail.on('change', function () {
    if (inputEmail.val() === '') {
      inputEmail.siblings('.error-message').text(strings.mandatoryField)
    } else {
      inputEmail.siblings('.error-message').text(strings.emailIncorrectlyFormatted)
    }
  })

  $('#newsletterRegisterButton').on('click', function () {
    const newsletterSignUpButton = $(this)

    if (inputEmail.val() === '') {
      inputEmail.siblings('.error-message').text(strings.mandatoryField)
    } else {
      inputEmail.siblings('.error-message').text(strings.emailIncorrectlyFormatted)
    }

    const form = document.getElementById('newsletter')

    // const inputEmail = $('input[name=pf_Email]')

    const formData = new FormData(form)  //eslint-disable-line
    const checkDefaultValidation = checkFormFields(formData)

    if (checkDefaultValidation) {
      return
    }

    if (!inputEmail || !inputEmail.length) return

    const divError = inputEmail.next()
    const divParent = inputEmail.parent()

    if (inputEmail.val() === '') {
      divParent.addClass('cell--error')
      divError.text(strings.emailMaxSize)
      divError.show()
      $('[data-target=email]').removeClass('active')

      return
    }

    if (inputEmail.val().length > 255) {
      divParent.addClass('cell--error')
      divError.text(strings.emailMaxSize)
      divError.show()
      $('[data-target=email]').removeClass('active')

      return
    }

    if (inputEmail.val().length < 7) {
      divParent.addClass('cell--error')
      divError.text(strings.emailMinSize)
      divError.show()
      $('[data-target=email]').removeClass('active')

      return
    }

    const reg = /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,})$/
    if (reg.test(inputEmail.val()) === false) {
      divParent.addClass('cell--error')
      divError.text(strings.emailIncorrect)
      divError.show()
      $('[data-target=email]').removeClass('active')

      return
    }

    divError.hide()
    divParent.removeClass('cell--error')
    $('[data-target=email]').addClass('active')

    if (!$('#newsletterTerms').is(':checked')) {
      showErrorMessage({ message: strings.consentTerms })
      return
    }

    let counter = 0
    const mailListsCounter = $('input[name=pf_CounterMailinglists]')
    const mailListsValue = mailListsCounter.val() || 0

    for (let i = 1; i <= mailListsValue; i++) {
      const checkBoxName = 'pf_MailinglistName' + i
      if (!document.getElementsByName(checkBoxName).length) return

      if (document.getElementsByName(checkBoxName)[0].checked || document.getElementsByName(checkBoxName)[0].type === 'hidden') counter++
    }

    if (counter === 0) {
      showErrorMessage({ message: strings.oneOrMoreListAreNecessary })
      return
    }

    $('#form-referral-message').addClass('login-card__alert--hide')

    const newsletterFormActionURL = form.getAttribute('action')

    newsletterSignUpButton.addClass('btn--loading disabled')
    newsletterSignUpButton.attr('disabled', true)

    fetch(newsletterFormActionURL, {
      method: 'POST',
      body: sanitizesFormData(formData)
    }).then(response => {
      if (response.status >= 200 && response.status <= 299) {
        const newsletterSignUpSection = document.querySelector('.newsletter-signup')
        const newsletterConfirmationSection = document.getElementById('newsletter-confirmation')
        const newsletterConfirmationHtmlArea = newsletterConfirmationSection.querySelector('.htmlArea')

        newsletterConfirmationSection.style.display = 'block'
        newsletterSignUpSection.style.display = 'none'
        newsletterConfirmationHtmlArea.innerHTML = strings.successMessage
        return
      }

      showErrorMessage({ message: strings.errorMessage })
    }).finally(() => {
      newsletterSignUpButton.removeClass('btn--loading disabled')
      newsletterSignUpButton.removeAttr('disabled')
    })
  })
})

/**
 * Receives a FormData object, removes not allowed properties and return the FormData entries as object
 * @param {FormData} formData
 * @returns {FormData}
 */
function sanitizesFormData (formData) {
  const validProperties = [
    'pf_SubscriberName',
    'pf_Email',
    'pf_FormType',
    'pf_OptInMethod',
    'pf_CounterDemogrFields',
    'pf_CounterMailinglists',
    'pf_AccountId',
    'pf_ListById',
    'pf_DeliveryFormat',
    'pf_Version',
    'pf_MailinglistName1',
    'Submit'
  ]

  for (const [key] of formData.entries()) {
    if (!validProperties.some(validProperty => validProperty === key)) {
      formData.delete(key)
    }
  }

  return formData
}

/**
 * Shows an HTML with an error message
 * @param {Object} params
 * @param {String} params.message error message
 */
function showErrorMessage ({ message }) {
  const errorMessageElement = document.getElementById('form-newsletter-message')
  const errorMessageTextElement = errorMessageElement.querySelector('p')

  errorMessageElement.classList.add('login-card__alert--error')
  errorMessageElement.classList.remove('login-card__alert--hide')

  errorMessageTextElement.innerHTML = message
}
